import { render } from "./Icons.vue?vue&type=template&id=3d6daf99&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=3d6daf99&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6daf99"]])

export default __exports__